import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./InventoryAddEquivDataCard.module.css";

const InventoryAddEquivDataCard = ({ data }) => {
  const { t, i18n } = useTranslation("pharmacySites");
  return (
    <div className={styles.inventoryAddEquivDataCard__container}>
      <div className={styles.inventoryAddEquivDataCard__dataList}>
        <div className={styles.inventoryAddEquivDataCard__rowGroup}>
          <div
            className={`${styles.inventoryAddEquivDataCard__colGroup} ${styles["inventoryAddEquivDataCard__colGroup--1"]}`}
          >
            <div className={`${styles["inventoryAddEquivDataCard__heading"]}`}>
              {data.idHeading}:
            </div>
            <div className={`${styles["inventoryAddEquivDataCard__value"]}`}>
              {data.id}
            </div>
            <div className={styles.inventoryAddEquivDataCard__actions}>
              <div className={`${styles["inventoryAddEquivDataCard__value"]}`}>
                {data.actions}
              </div>
            </div>
          </div>
        </div>

        <div className={styles.inventoryAddEquivDataCard__rowGroup}>
          <div
            className={`${styles.inventoryAddEquivDataCard__colGroup} ${styles["inventoryAddEquivDataCard__colGroup--1"]}`}
          >
            <div className={`${styles["inventoryAddEquivDataCard__heading"]}`}>
              {data.descriptionHeading}:
            </div>
            <div className={`${styles["inventoryAddEquivDataCard__value"]}`}>
              {data.description}
            </div>
          </div>
        </div>

        <div className={styles.inventoryAddEquivDataCard__rowGroup}>
          <div
            className={`${styles.inventoryAddEquivDataCard__colGroup} ${styles["inventoryAddEquivDataCard__colGroup--1"]}`}
          >
            <div className={`${styles["inventoryAddEquivDataCard__heading"]}`}>
              {data.manufacturerHeading}:
            </div>
            <div className={`${styles["inventoryAddEquivDataCard__value"]}`}>
              {data.manufacturer}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InventoryAddEquivDataCard;
